{
 "note": "made by tools/make-station-art.py from assets/stations; do not edit",
 "aspect": 0.6948,
 "stations": {
  "GTB Nagar": {
   "image": "/sprites/stations/gtb-nagar.png",
   "w": 728,
   "h": 1048
  },
  "Vishwa Vidyalaya": {
   "image": "/sprites/stations/vishwa-vidyalaya.png",
   "w": 728,
   "h": 1048
  },
  "Vidhan Sabha": {
   "image": "/sprites/stations/vidhan-sabha.png",
   "w": 728,
   "h": 1048
  },
  "Civil Lines": {
   "image": "/sprites/stations/civil-lines.png",
   "w": 728,
   "h": 1048
  },
  "Kashmere Gate": {
   "image": "/sprites/stations/kashmere-gate.png",
   "w": 728,
   "h": 1048
  },
  "Chandni Chowk": {
   "image": "/sprites/stations/chandni-chowk.png",
   "w": 728,
   "h": 1048
  },
  "Chawri Bazaar": {
   "image": "/sprites/stations/chawri-bazaar.png",
   "w": 728,
   "h": 1048
  },
  "New Delhi": {
   "image": "/sprites/stations/new-delhi.png",
   "w": 728,
   "h": 1048
  },
  "Rajiv Chowk": {
   "image": "/sprites/stations/rajiv-chowk.png",
   "w": 728,
   "h": 1048
  },
  "Patel Chowk": {
   "image": "/sprites/stations/patel-chowk.png",
   "w": 728,
   "h": 1048
  }
 }
}
